import React from 'react';
import './PrivacyPolicy.css';

const PrivacyPolicy = () => {
  return (
    <div className="privacy-policy-container">
      <h1 className="title">Privacy Policy</h1>
      <p className="updated-date"><strong>Last Updated:</strong> June 12, 2025</p>

      <p>
        At <strong>VORTREX</strong>, your privacy and wallet control are our top priority. This Privacy Policy explains how we handle your information when you use the VORTREX AI Trading Bot and interact with our platform.
      </p>

      <h2>🔍 Information We Collect</h2>
      <ul>
        <li><strong>Public Wallet Address:</strong> Required to enable bot functionality and track interaction.</li>
        <li><strong>Email Address (Optional):</strong> Only if you voluntarily subscribe for bot updates or alerts.</li>
        <li><strong>Analytics Data:</strong> Anonymous usage data via trusted tools like Google Analytics to improve platform performance.</li>
      </ul>
      <p><strong>Note:</strong> We do <u>not</u> collect or store private keys, seed phrases, or wallet passwords at any time.</p>

      <h2>📦 How We Use Your Information</h2>
      <ul>
        <li>To operate the wallet-based trading bot effectively</li>
        <li>To provide technical support and notify about system updates</li>
        <li>To analyze usage for performance improvements (non-personal data only)</li>
      </ul>

      <h2>🔐 Security</h2>
      <p>
        We follow standard security practices to safeguard your basic information. However, users are fully responsible for the security of their own crypto wallets and devices.
      </p>

      <h2>🚫 No Financial Advice</h2>
      <p>
        VORTREX is a community-driven automation tool. It does not guarantee returns or provide any form of investment advice. Participation is voluntary. Always DYOR (Do Your Own Research).
      </p>

      <h2>🌐 Third-Party Tools & Links</h2>
      <p>
        Our interface may integrate or link to third-party DApps, tools, or analytics. We are not liable for their policies or behavior.
      </p>

      <h2>👤 Your Rights</h2>
      <ul>
        <li>You may disconnect your wallet anytime via the app interface</li>
        <li>You can request deletion of any voluntarily submitted data via email</li>
      </ul>

      <h2>📬 Contact Us</h2>
      <p>
        For privacy-related inquiries or data removal requests, reach out to us:<br />
        <strong>Email:</strong> support@vortrex.live<br />
        <strong>Website:</strong> <a href="https://vortrex.live" target="_blank" rel="noopener noreferrer">https://vortrex.live</a>
      </p>
    </div>
  );
};

export default PrivacyPolicy;
